<template>
	<div class="workbenchPageWrap">
		<span class="leftContent"
			>显示{{ showNum }}，共{{ totalCount }}条记录</span
		>
		<el-pagination
			@size-change="handleSizeChange"
			@current-change="handleCurrentChange"
			:current-page="pageIndex"
			:page-sizes="[10, 20, 30, 50, 100]"
			:page-size="pageSize"
			layout="total, prev, pager, next, sizes, jumper"
			:total="totalCount"
		></el-pagination>
	</div>
</template>

<script>
export default {
	name: "page",
	props: {
		totalCount: {
			default: 0,
			type: Number,
		},
		pageIndex: {
			default: 1,
			type: Number,
		},
		pageSize: {
			default: 10,
			type: Number,
		},
	},
	computed: {
		showNum() {
			return this.totalCount > 0
				? (this.pageIndex - 1) * this.pageSize +
						1 +
						"-" +
						(this.pageIndex * this.pageSize > this.totalCount
							? this.totalCount
							: this.pageIndex * this.pageSize)
				: "0";
		},
	},
	methods: {
		handleCurrentChange(val) {
			this.$emit("pageChange", {
				type: "pageIndex",
				value: val,
			});
		},
		handleSizeChange(val) {
			this.$emit("pageChange", {
				type: "pageSize",
				value: val,
			});
		},
	},
};
</script>

<style scoped lang="scss">
.workbenchPageWrap {
	display: flex;
	justify-content: space-between;
	align-items: center;
	height: 60px;

	.leftContent {
		color: #666666;
		font-size: 14px;
	}
}
</style>
